<template>
    <b-form @submit.prevent="validateFormGeneral()" data-vv-scope="hygienic_measurements">
        <b-row>
            <b-col cols="4">
                <b-form-group>
                    <label for="code">Código</label>
                    <el-input id="code" name="code" v-model="hygienic_measurement.code" data-vv-as=" "
                        v-validate="'required|max:255'" maxlength="255" />
                    <div class="text-danger small" v-text="errors.first('hygienic_measurements.code')" />

                </b-form-group>
            </b-col>

            <b-col cols="4">
                <b-form-group>
                    <label for="code_short">Código abreviado</label>
                    <el-input id="code_short" name="code_short" v-model="hygienic_measurement.code_short" data-vv-as=" "
                        v-validate="'|max:255'" maxlength="255" />
                    <div class="text-danger small" v-text="errors.first('hygienic_measurements.code_short')" />

                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group>
                    <label for="name">Nombre</label>
                    <el-input id="name" name="name" v-model="hygienic_measurement.name" data-vv-as=" "
                        v-validate="'required|min:3|max:255'" maxlength="255" show-word-limit />
                    <div class="text-danger small" v-text="errors.first('hygienic_measurements.name')" />

                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group>
                    <label for="positions">
                        Cargos
                    </label>
                    <el-select v-model="hygienic_measurement.positions" id="positions" name="positions" filterable
                        class="w-100" placeholder="Seleccione un Cargo" no-data-text="No hay datos que coincidan"
                        no-match-text="No hay datos que coincidan" data-vv-as=" " multiple>
                        <el-option v-for="position in positions" :key="position.id" :label="position.name"
                            :value="position.id" />
                    </el-select>
                    <div class="text-danger small" v-text="errors.first('hygienic_measurements.positions')" />
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group>
                    <label for="roles">
                        Rol
                    </label>
                    <el-select v-model="hygienic_measurement.role_id" id="roles" name="roles" filterable
                        placeholder="Seleccione un Rol" class="w-100" no-data-text="No hay datos que coincidan"
                        no-match-text="No hay datos que coincidan" data-vv-as=" ">
                        <el-option v-for="role in workRolesActive" :key="role.id" :label="role.name" :value="role.id" />
                    </el-select>
                    <div class="text-danger small" v-text="errors.first('hygienic_measurements.roles')" />
                </b-form-group>
            </b-col>

            <!-- <b-col cols="6">
                <b-form-group>
                    <label for="sites">
                        Locación
                    </label>
                    <el-select v-model="hygienic_measurement.site_id"
                               id="sites"
                               name="sites"
                               filterable
                               placeholder="Seleccione una Locación"
                               class="w-100"
                               no-data-text="No hay datos que coincidan"
                               no-match-text="No hay datos que coincidan"
                               data-vv-as=" "
                    >
                        <el-option v-for="site in sitesActive"
                                   :key="site.id"
                                   :label="site.name"
                                   :value="site.id"
                        />
                    </el-select>
                    <div class="text-danger small"
                         v-text="errors.first('hygienic_measurements.sites')"
                    />
                </b-form-group>
            </b-col> -->

            <b-col cols="6">
                <b-form-group>
                    <label for="locations">
                        Ubicación
                    </label>
                    <Treeselect v-if="Array.isArray(hygienic_measurement.locations) && typeof hygienic_measurement.locations[0] !== 'object'"
                        :value="hygienic_measurement.locations" name="locations" id="locations" clearable multiple
                        :options="arbolUbicaciones" :normalizer="normalizer" placeholder="Seleccionar"
                        :flatten-search-results="true" data-vv-as=" " v-validate="'required'" :disable-branch-nodes="true"
                        v-model="hygienic_measurement.locations" :defaultExpandLevel="Infinity"
                        no-results-text="No se encontraron resultados." :max-height="300" class="custom-treeselect"
                        value-consists-of="ALL" noOptionsText="No hay resultados para mostrar">
                        <label slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName">
                            {{ node.label }}
                        </label>
                    </Treeselect>
                    <div class="text-danger small" v-text="errors.first('hygienic_measurements.locations')" />
                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group>
                    <label for="description">Descripción</label>
                    <el-input id="description" name="description" type="textarea" size="small"
                        v-model="hygienic_measurement.description" data-vv-as=" " v-validate="'max:1000'"
                        maxlength="1000" show-word-limit />
                    <div class="text-danger small" v-text="errors.first('hygienic_measurements.description')" />
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col class="text-center">
                <hr />

                <b-btn variant="primary" class="mx-1" size="sm" @click="validateFormGeneral()">
                    Guardar
                    <i class="fa fa-save" />
                </b-btn>
                <b-btn variant="secondary" class="mx-1" size="sm" @click="setModal()">
                    <i class="fa fa-close" /> Cancelar
                </b-btn>
            </b-col>
        </b-row>
    </b-form>
</template>


<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import Treeselect from "@riophae/vue-treeselect";

export default {
    name: 'hygienic_measurement',
    components: {
        Treeselect,
    },
    props: {
        companyId: {
            type: Number,
            required: false,
        },
        isComponent: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            company_id: this.$route.params.id,
            value: null,
        };
    },
    computed: {
        ...mapState('hygienic_measurements', [
            'hygienic_measurement',
            'modal',
            'positions',
            'editing',
        ]),
        ...mapState('rolesWorker', [
            'workRolesActive',
        ]),
        ...mapState('location', [
            'arbolUbicaciones',
        ]),
        ...mapState('sites', [
            'sitesActive',
        ]),
    },
    async mounted() {
        if(this.isComponent) {
            this.resetHygienicMeasurement();
            this.setEditing(false);
        }
        if (this.companyId) {
            this.company_id = this.companyId;
        }
        await this.listWorkRolesActive(this.company_id);
        await this.arbolUbicacionesEmpresa(this.company_id);
        // await this.getAllActive(this.company_id);
        if (this.hygienic_measurement.locations) {
            this.hygienic_measurement.locations = this.hygienic_measurement.locations.map(location => location.location_id);
        }
    },
    methods: {
        ...mapActions('hygienic_measurements', [
            'addHygienicMeasurement',
            'updateHygienicMeasurement',
        ]),
        ...mapActions('rolesWorker', [
            'listWorkRolesActive',
        ]),
        ...mapActions('location', [
            'arbolUbicacionesEmpresa',
        ]),
        ...mapActions('sites', [
            'getAllActive',
        ]),
        ...mapMutations('hygienic_measurements', [
            'setModalShow',
            'resetHygienicMeasurement',
            'setEditing',
        ]),
        validateFormGeneral() {
            this.$validator.validateAll('hygienic_measurements')
                .then(async (result) => {
                    if (result) {
                        if (!this.editing) {
                            const res = await this.addHygienicMeasurement(this.company_id);
                            if (this.isComponent && res) {
                                this.closeComponent();
                            }
                        } else {
                            await this.updateHygienicMeasurement();
                        }
                    }
                });
        },
        normalizer(node) {
            return {
                children: node.children && node.children.length ? node.children : 0,
            };
        },
        setModal() {
            if (this.isComponent) {
                this.closeComponent();
            } else {
                this.setModalShow(false);
            }
        },
        closeComponent() {
            this.$emit('close');
            this.resetHygienicMeasurement();
        },
    },
};
</script>
